import React, { useEffect } from "react";
import DropTrackProducts from "../../Pages/DropTrackProducts/DropTrackProducts.Page";
import { Route, Routes } from "react-router-dom";
import DropTrackProductInsightPage from "../../Pages/DropTrackProductInsight/DropTrackProductInsight.Page";
import { useDispatch, useSelector } from "react-redux";
import { fetchfetchDropTrackList } from "../../Features/dropTrackProductsSlice";
import Loading from "../../Components/Loading/Loading";

function DropTrackProductsRoute() {
    const dispatch = useDispatch();
    
    const loading = useSelector(
        (state) => state.dropTrackProducts.dropTrackList.loading
    );

    useEffect(() => {
        dispatch(fetchfetchDropTrackList());
        // eslint-disable-next-line
    }, []);

    return (
        <Routes>
            <Route
                index
                element={
                    <>
                        {
                            loading === "loading" ? 
                            <Loading /> : 
                            <DropTrackProducts />
                        }
                    </>
                }
            />

            <Route path=":productId" element={<DropTrackProductInsightPage />} />
        </Routes>
    );
}

export default DropTrackProductsRoute;
